import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts';
import useWindowDimensions from '../../../../utils/useWindowDimensions';


const PlatformUsage = ({ chartLabels }) => {
    let {width , height} = useWindowDimensions()

    const chartData = {
        series: [
                 {
                    name: "Guided",
                    data: chartLabels.map((e)=>e.counts.guided)
                 },
                 {
                    name: "Unguided",
                    data: chartLabels.map((e)=>e.counts.unguided)
                 },
                ],
        options: {
            chart: {
                type: 'line',
                zoom: {
                    enabled: false
                },
                toolbar: {
                    show: false
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 3
            },
            grid: {
                row: {
                    colors: ['#f3f3f3', 'transparent'],
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: chartLabels.map((e)=>e.label),
            },
            colors: ["#3e4095","#333"],

        }
    };


    return (
        <>
            <div id="chart">
                <ReactApexChart options={chartData.options} series={chartData.series} type="line"
                 height={width > 1500 ? 250 : 198 } />
            </div>
        </>
    )
}

export default PlatformUsage